import { Helmet } from 'react-helmet-async';
import { filter } from 'lodash';
import { sentenceCase } from 'change-case';
import { useState, useCallback, useEffect } from 'react';

// @mui
import {
  Card,
  Table,
  Stack,
  Paper,
  Avatar,
  Button,
  Popover,
  Checkbox,
  TableRow,
  MenuItem,
  TableBody,
  TableCell,
  Container,
  Typography,
  IconButton,
  TableContainer,
  TablePagination,
} from '@mui/material';
// components
import Label from '../components/label';
import Iconify from '../components/iconify';
import Scrollbar from '../components/scrollbar';
// sections
import { UserListHead, UserListToolbar } from '../sections/@dashboard/user';
// mock
// import USERLIST from '../_mock/devices_list';

// console.log(USERLIST);

// ----------------------------------------------------------------------

const TABLE_HEAD = [
  { id: 'IMEI', label: 'IMEI', alignCentar: true },
  { id: 'vlasnik', label: 'Vlasnik', alignRight: false },
  { id: 'ime', label: 'Ime', alignRight: false },
  { id: 'tiptrackera', label: 'Tip trackera', alignRight: false },
  { id: 'aktivan', label: 'Aktivan', alignRight: false },
  { id: 'online', label: 'Online', alignRight: false },
  { id: 'today', label: 'Today', alignRight: false },
  { id: 'blokiran', label: 'Blokiran', alignRight: false },
  { id: 'saldo', label: 'Saldo', alignRight: false },
  { id: 'last', label: 'Last seen', alignRight: false },
  { id: '' },
];

// ----------------------------------------------------------------------

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  if (query) {
    return filter(array, (_user) => _user.vlasnik.toLowerCase() === query.toLowerCase());
  }
  return stabilizedThis.map((el) => el[0]);
}

export default function UserDevicesPage(props) {
  const [open, setOpen] = useState(null);

  const [page, setPage] = useState(0);

  const [order, setOrder] = useState('asc');

  const [selected, setSelected] = useState([]);
  
  const [users, setUsers] = useState([]);

  const [orderBy, setOrderBy] = useState('IMEI');

  const [filterName, setFilterName] = useState(props.vlasnik);

  return (
    <>
      
    </>
  );
}
